import { put, call, takeLatest } from "redux-saga/effects";

import * as Actions from "redux/actions/RoleModule";
import * as Types from "redux/constants/RoleModule";

import RoleModuleService from "services/RoleModuleService";

export function* fetchRoleModulesEffect({ payload }) {
    try {
        const { data: roleModules } = yield call(RoleModuleService.fetch, payload);
        const formattedPermissions = roleModules.map((roleModule) => ({
            ...roleModule,
            key: roleModule.moduleId
        }))
        yield (put(Actions.fetchRoleModulesOk(formattedPermissions)));
    } catch ({ response }) {
        yield (
            put(
                Actions.fetchRoleModulesFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: []
                })
            )
        );
    }
}

export function* attachModuleEffect({ payload }) {
    try {
        const { data } = yield call(RoleModuleService.attachModule, payload);
        yield (put(Actions.attachModuleOk(data)));

    } catch ({ response }) {
        yield (
            put(
                Actions.attachModuleFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: response.data.data.errors ? response.data.data.errors : null,
                })
            )
        );
    }
}

export function* fetchRolePermissionsEffect({ payload }) {
    try {
        const { data: roleModule } = yield call(RoleModuleService.fetchRolePermissions, payload);
        yield (put(Actions.fetchRolePermissionsOk(roleModule)));
    } catch ({ response }) {
        yield (
            put(
                Actions.attachModuleFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: [],
                })
            )
        );
    }
}

export default function* rootSaga() {
    yield takeLatest(Types.ATTACH_MODULE, attachModuleEffect);
    yield takeLatest(Types.FETCH_ROLE_MODULES, fetchRoleModulesEffect);
    yield takeLatest(Types.FETCH_ROLE_PERMISSIONS, fetchRolePermissionsEffect);
}
